import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";
import { motion } from "framer-motion";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function KioskLayout({ children, showBack = true, showHome = true, step = "" }) {
  const navigate = useNavigate();
  const [settings, setSettings] = useState({ clinic_name: "Clínica", logo_url: null });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/settings`);
      setSettings(response.data);
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  return (
    <div className="kiosk-mode min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 px-8 py-4 flex items-center justify-between">
        <div className="flex items-center gap-6">
          {showBack && (
            <button
              data-testid="kiosk-back-btn"
              onClick={() => navigate(-1)}
              className="h-14 w-14 rounded-full bg-slate-100 hover:bg-slate-200 active:scale-95 transition-all flex items-center justify-center"
            >
              <ArrowLeft className="w-7 h-7 text-slate-700" />
            </button>
          )}
          <div className="flex items-center gap-4">
            {settings.logo_url ? (
              <img
                src={settings.logo_url.startsWith("http") ? settings.logo_url : `${API_URL}${settings.logo_url}`}
                alt="Logo"
                className="h-12 w-auto object-contain"
              />
            ) : (
              <div className="h-12 w-12 bg-[#00357C] rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">
                  {settings.clinic_name?.charAt(0) || "C"}
                </span>
              </div>
            )}
          </div>
        </div>

        <div className="flex items-center gap-4">
          {step && (
            <span className="text-lg text-slate-500">{step}</span>
          )}
          {showHome && (
            <button
              data-testid="kiosk-home-btn"
              onClick={() => navigate("/")}
              className="h-14 w-14 rounded-full bg-[#00357C] hover:bg-[#002d59] active:scale-95 transition-all flex items-center justify-center"
            >
              <Home className="w-7 h-7 text-white" />
            </button>
          )}
        </div>
      </header>

      {/* Main Content */}
      <motion.main
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="flex-1 flex flex-col"
      >
        {children}
      </motion.main>
    </div>
  );
}
